import React from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { languages } from "../../constants/languages";

export default class TeamsAsRefereesDialog extends React.Component {
  render() {
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.toggleDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {languages.formatString(
            this.props.tournament.useJudges
              ? languages.referees.teamsAsJudges
              : languages.referees.teamsAsReferees,
            this.props.tournament.individualPlayers
              ? languages.teams.playersLow.charAt(0).toUpperCase() +
                  languages.teams.playersLow.slice(1)
              : languages.tournament.teamsLow.charAt(0).toUpperCase() +
                  languages.tournament.teamsLow.slice(1)
          )}
        </DialogTitle>
        <DialogContent
          style={{ width: 350, maxWidth: "97%", paddingBottom: 0 }}
        >
          <DialogContentText>
            {!this.props.tournament.teamsAsRefs
              ? languages.formatString(
                  this.props.tournament.useJudges
                    ? languages.referees.createTeamsAsJudgesDescription
                    : languages.referees.createTeamsAsRefereesDescription,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )
              : languages.formatString(
                  this.props.tournament.useJudges
                    ? languages.referees.deleteTeamsAsJudgesDescription
                    : languages.referees.deleteTeamsAsRefereesDescription,
                  this.props.tournament.individualPlayers
                    ? languages.teams.playersLow
                    : languages.tournament.teamsLow
                )}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Button onClick={this.props.toggleDialog} color="primary">
            {languages.general.cancel}
          </Button>
          <Button
            onClick={this.props.handleSwitch}
            variant="contained"
            color="primary"
          >
            {languages.general.continue}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}
